import moment from "moment-timezone";
import { DATE_FORMAT_2 } from "./date";
import { Keys as StatusKeys } from "../constant/status";
import { ORDER_TYPES } from "../constant/filters";

/**
 * Parses URL query parameters and converts them to filter format
 */
export const parseUrlFilters = (searchParams, replacementYears = 1) => {
  const filters = {};

  const type = searchParams.get("type");
  const trigger = searchParams.get("trigger");
  const orderDate = moment().subtract(1, "day").format(DATE_FORMAT_2);
  const todayDate = moment().format(DATE_FORMAT_2);
  const endOfWeekDate = moment().endOf("week").format(DATE_FORMAT_2);

  if (type) {
    if (type === "pending") {
      filters.statusesFilter = [StatusKeys.order_required];
      filters.orderDateFilter =
        trigger === "Weekly"
          ? { fromDate: todayDate, toDate: endOfWeekDate }
          : { fromDate: todayDate, toDate: todayDate };
    } else {
      const startDate = moment().subtract(replacementYears, "years").format(DATE_FORMAT_2);

      filters.orderDateFilter = {
        fromDate: startDate,
        toDate: orderDate
      };
      if (type === "ReplacementDrug") {
        filters.statusesFilter = [StatusKeys.drug_dispensed];
        filters.orderTypesFilter = [ORDER_TYPES.REPLACEMENT.value];
      } else if (type === "FreeDrug") {
        filters.statusesFilter = [StatusKeys.order_required];
        filters.orderTypesFilter = [ORDER_TYPES.FREE.value];
      }
    }
  }

  const assignee = searchParams.get("assignee");
  if (assignee) {
    filters.assigneesFilter = [assignee];
  }

  return filters;
};

export const hasUrlFilters = (searchParams) => {
  return searchParams.has("type") || searchParams.has("assignee") || searchParams.has("trigger");
};
